import Accounts from "../Accounts/Index";
import Nav from "../Navigation/Nav";
import Page from "../Helper/Page";
import React from "react";

const Home = () => {
  return (
    <Page>
      <section className="flex flex-col h-full sm:grid sm:grid-cols-[minmax(225px,25%)_auto] lg:grid-cols-[minmax(225px,15%)_auto]">
        <Nav />
        <Accounts />
      </section>
    </Page>
  );
};

export default Home;
